import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, inject } from '@angular/core';
import {AuthenticationService, profileType} from 'app/services/auth.service';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {APIService} from "app/services/api.service";
import {LoaderService} from "app/services/loader.service";
import { NgbModal, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import {AdvisorContactComponent} from "app/modules/shared/advisor-contact.component";
import { NgClass } from '@angular/common';
import { AdvisorContactComponent as AdvisorContactComponent_1 } from '../../shared/advisor-contact.component';

/**
 * it would open a form so that the user can request some manipulations in its info
 */
@Component({
    selector: 'app-request-to-update-information',
    templateUrl: './request-to-update-information.component.html',
    styleUrls: ['./request-to-update-information.component.scss'],
    imports: [NgbTooltip, FormsModule, ReactiveFormsModule, NgClass, AdvisorContactComponent_1]
})
export class RequestToUpdateInformationComponent implements OnInit {
  private fb = inject(FormBuilder);
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  modalService = inject(NgbModal);
  loaderService = inject(LoaderService);

  // user's brief info. It's assumed, userProfile has value once the component is initialized.
  @Input() profile!: profileType;
  @Input() reRgId!: number;
  // notify the parent to close the form
  @Output() cancelRequest = new EventEmitter<void>();
  profileForm: FormGroup;
  errorMessage = '';
  isImpersonated = false;

  constructor() {
    this.profileForm = this.fb.group({
      Name: [''],
      EmailAddress: ['', Validators.email],
      PhoneNumber: [''],
      Fax: [''],
      noMailingAddress: [false],
      Address1: [''],
      Address2: [''],
      Address3: [''],
      City: [''],
      Province: [''],
      Country: [''],
      Postal: ['']
    });
  }

  ngOnInit() {
    this.isImpersonated = !!sessionStorage.getItem('guid');
    this.fillTheForm();
    // if noMailingAddress field is selected -> all the address values should become empty & hidden.
    this.profileForm.get('noMailingAddress')?.valueChanges.subscribe(value => {
      if (value) {
        this.profileForm.get('Address1')?.setValue('');
        this.profileForm.get('Address2')?.setValue('');
        this.profileForm.get('Address3')?.setValue('');
        this.profileForm.get('City')?.setValue('');
        this.profileForm.get('Province')?.setValue('');
        this.profileForm.get('Country')?.setValue('');
        this.profileForm.get('Postal')?.setValue('');
      }
    });
  }

  /**
   * all the changes in the form should be reflected in this message so that the business apply the user's requested changes.
   */
  getRequestMessage(): string {
    let changeDetected = false;
    let message = '<br>';
    const userInfoProperties: Array<keyof profileType> = [
      'Name',
      'EmailAddress',
      'PhoneNumber',
      'Fax',
      'Address1',
      'Address2',
      'Address3',
      'City',
      'Province',
      'Country',
      'Postal',
    ];
    userInfoProperties.forEach(str => {
      if (this.profileForm.get(str)?.value !== this.profile[str]) {
        changeDetected = true;
        message += `<span style="font-weight: bold">${str}</span>: From '${this.profile[str]}' to '${this.profileForm.get(str)?.value}'.`;
        message += '<br>';
      }
    });
    return changeDetected ? message : '';
  }

  /**
   * send the change request to server.
   */
  onSubmit(content: TemplateRef<AdvisorContactComponent>) {
    this.errorMessage = '';
    if (this.profileForm?.valid) {
      const message = this.getRequestMessage();
      if( message === '' ) {
        this.errorMessage = 'No change is detected in the form';
        return;
      }
      const formData: FormData = new FormData();
      formData.append('message', this.getRequestMessage());
      formData.append('subject', '2');
      formData.append('option',  'email');
      formData.append('reRgId',  this.reRgId.toString());
      formData.append('reId',  this.profile.NameId?.toString() ?? '');

      this.loaderService.display(true);
      this.api.sendMailWithAttachments(formData).subscribe(
        () => {
          this.loaderService.display(false);
          this.modalService.open(content, { size: 'lg' });
          this.cancelRequest.emit();
        },
        () => {
          this.errorMessage = 'Server Error';
            this.loaderService.display(false);
        }
      );
    }
  }

  /**
   * it would fill the form based on profile provided by parent component.
   */
  public fillTheForm(event?: Event): void {
    event?.preventDefault();
    const addressRelatedFields = ['Address1', 'Address2', 'Address3', 'City', 'Province', 'Country', 'Postal'];
    this.profileForm.setValue({
      Name: this.profile.Name,
      EmailAddress: this.profile.EmailAddress,
      PhoneNumber: this.profile.PhoneNumber,
      Fax: this.profile.Fax,
      noMailingAddress: false,
      Address1: this.profile.Address1,
      Address2: this.profile.Address2,
      Address3: this.profile.Address3,
      City: this.profile.City,
      Province: this.profile.Province,
      Country: this.profile.Country,
      Postal: this.profile.Postal,
    });
    this.profileForm.get('noMailingAddress')?.setValue(
      addressRelatedFields.map(str => this.profileForm.get(str)?.value).filter(str => str != null && str !== '').length === 0
    );

  }
}
